import api from './api';

// Service pour gérer les opérations d'authentification
const authService = {
  // Connexion utilisateur
  login: async ({ email, mdp }) => {
    try {
      const response = await api.post('/auth/login', { email, mdp });
      const donnees = response.data;
      if (donnees.data.token) {
        // Stocker le token avec les deux noms pour compatibilité
        localStorage.setItem('token', donnees.data.token);
        localStorage.setItem('authToken', donnees.data.token);
        localStorage.setItem('user', JSON.stringify(donnees.data.compte));
      }
      return donnees.data;
    } catch (error) {
      throw error;
    }
  },

  // 🔹 Connexion via Google
  googleLogin: async (idToken) => {
    try {
      const response = await api.post('/auth/google', { id_token: idToken });
      const donnees = response.data;

      if (donnees.data?.token) {
        localStorage.setItem('token', donnees.data.token);
        localStorage.setItem('authToken', donnees.data.token);
        localStorage.setItem('user', JSON.stringify(donnees.data.compte));
      }

      return donnees.data;
    } catch (error) {
      throw error;
    }
  },

  // Inscription utilisateur
  register: async (userData) => {
    try {
      const response = await api.post('/auth/register', userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Déconnexion utilisateur
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
  },

  // Récupérer l'utilisateur actuel
  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    if (user) {
      try {
        const parsedUser = JSON.parse(user);
        
        // Vérifier que l'objet utilisateur a les champs requis
        if (!parsedUser._id || !parsedUser.email) {
          localStorage.removeItem('user');
          localStorage.removeItem('token');
          localStorage.removeItem('authToken');
          return null;
        }
        
        return parsedUser;
      } catch (error) {
        console.error('Erreur lors du parsing de l\'utilisateur:', error);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('authToken');
        return null;
      }
    }
    return null;
  },

  // Vérifier si l'utilisateur est connecté
  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },

  // Vérifier si l'utilisateur est un administrateur
  isAdmin: () => {
    const user = authService.getCurrentUser();
    return user && user.role === 'admin';
  },

  // Mettre à jour le profil utilisateur
  updateProfile: async (userData) => {
    try {
      const response = await api.put('/auth/profile', userData);
      
      // Mettre à jour les informations dans le localStorage
      if (response.data.user) {
        localStorage.setItem('user', JSON.stringify(response.data.user));
      }
      
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Changer le mot de passe
  changePassword: async (currentPassword, newPassword) => {
    try {
      const response = await api.put('/auth/password', { 
        currentPassword, 
        newPassword 
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Demander une réinitialisation de mot de passe
  forgotPassword: async (email) => {
    try {
      const response = await api.post('/auth/forgot-password', { email });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Réinitialiser le mot de passe avec un token
  resetPassword: async (token, newPassword) => {
    try {
      const response = await api.post('/auth/reset-password', { 
        token, 
        newPassword 
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Récupérer le profil utilisateur
  getProfile: async () => {
    try {
      const response = await api.get('/auth/profile');
      
      // Mettre à jour les informations dans le localStorage
      if (response.data.data) {
        localStorage.setItem('user', JSON.stringify(response.data.data));
      }
      
      return {
        success: response.data.success,
        data: response.data.data,
        compte: response.data.data, // Pour compatibilité
        user: response.data.data    // Pour cohérence avec AuthContext
      };
    } catch (error) {
      console.error('❌ Erreur getProfile:', error);
      throw error;
    }
  }
};

export default authService;
